export default __webpack_public_path__ + "static/principle3-df484e5a6ce490f7390fa6f986d526cd8ec6069c867d6f8bf130cd08ec4f40b9.png";